import { isNil, isNumber } from 'lodash-es';

export type WeekRange = (number | null)[];
export const FIRST_WEEK_INDEX = 0;
export const THURSDAY_INDEX = 4;

export default class Inspector {
  public static isFirstWeek(weekIndex: number) {
    return FIRST_WEEK_INDEX === weekIndex;
  }

  /**
   * [null(일), null(월), null(화), null(수), null(목), 1, 2]와 같이
   * null이 4개보다 많다면 저번 달의 마지막 주로 판단
   */
  public static isWeekOfLastMonth(weekChunk: WeekRange) {
    return weekChunk.filter(isNil).length > THURSDAY_INDEX;
  }

  /**
   * [29, 30, 31, null(수), null(목), null(금), null(토)]와 같이
   * null이 4개 이상이면 다음 달의 첫번째 주로 판단
   */
  public static isWeekOfNextMonth(weekChunk: WeekRange) {
    return weekChunk.filter(isNumber).length <= THURSDAY_INDEX;
  }
}
